import React from "react";
import { gql } from "graphql-tag";
import { useMutation } from "@apollo/client";
import { createTeamUser, createTeamUserVariables, UserRole } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import { Viewer } from "components/auth/types";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { useSendEnrollmentEmail } from "pages/login/actions";
import UserForm from "pages/shared-forms/user";
import {
  cleanUserFormOutput,
  handleSubmitError,
  UserFormData,
} from "./shared-create-update";

export const CREATE_USER_MUTATION = gql`
  mutation createTeamUser($data: UserInput!) {
    createUser(data: $data) {
      id
      email
    }
  }
`;

type Props = {
  viewer: Viewer;
}

const CreateTeamMember: React.FC<Props> = (props) => {
  const [createUser, createUserMutation] = useMutation<createTeamUser, createTeamUserVariables>(
    CREATE_USER_MUTATION,
  );
  const { openSnackbar } = useSnackbar();
  const sendEnrollmentEmail = useSendEnrollmentEmail();

  const initialUserData = {
    firstName: "",
    lastName: "",
    title: "",
    directPhone: "",
    email: "",
    roles: [],
    lists: [],
    organizationId: props.viewer.organizationId,
  };

  const handleSubmit = async (values: UserFormData) => {
    const userInput = cleanUserFormOutput(values);
    const variables = { data: userInput };
    try {
      const resp = await createUser({ variables });
      if (resp.data && resp.data.createUser && resp.data.createUser.id) {
        await sendEnrollmentEmail(resp.data.createUser.id, openSnackbar);
        return;
      }
      handleSubmitError("CREATE");
    } catch {
      handleSubmitError("CREATE");
    }
  };

  return (
    <div>
      <h2 className="margin-bottom-l">Invite User</h2>

      <UserForm
        onSubmit={handleSubmit}
        initialData={initialUserData}
        isSending={createUserMutation.loading}
      />
    </div>

  );
};

export default authorizeForRole([UserRole.SUPERVISOR], CreateTeamMember);
